"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeTextSymbols = escapeTextSymbols;
// escapeTextSymbols replaces unescaped & and % with escaped \& and \% inside
// \text{} nodes. KaTeX required & and % to be unescaped inside \text{}, but
// MathJax requires them to be escaped, so we need to use this function to
// adapt our existing content to work with MathJax.
//
// escapeTextSymbols also replaces \textquotedblleft, \textquotedblright, and
// \textemdash with their unicode equivalents inside \text{}. While these
// commands exist in MathJax (if you have the textcomp package installed) they
// don't work inside \text{}.
// TODO(benchristel,LC-584): revise our content and remove this hack
function escapeTextSymbols(tex) {
    // The `textNodes` regex matches:
    //   the literal characters \text
    //   ... followed by optional space and an opening curly brace
    //   ... followed by one or more "text chars", where a "text char" is:
    //     - a TeX-escaped backslash (\\), or
    //     - a TeX-escaped closing curly brace (\}), or
    //     - a single character that isn't a closing curly brace
    //   ... followed by a closing curly brace
    const textNodes = /\\text\s*\{((\\\\|\\}|[^}])+)}/g;
    // The `maybeEscapedAmpersands` regex matches:
    //   zero or more TeX-escaped backslashes (\\)
    //   ... followed by an optional backslash (escaping the following '&')
    //   ... followed by an ampersand '&'
    // The escaped backslashes are in a capture group so they can be preserved
    // by the replace call ($1 refers to this capture group).
    // maybeEscapedPercentSigns and maybeEscapedHashtags use similar logic
    const maybeEscapedAmpersands = /((\\\\)*)\\?&/g;
    const maybeEscapedPercentSigns = /((\\\\)*)\\?%/g;
    const maybeEscapedHashtags = /((\\\\)*)\\?#/g;
    const leftQuoteMacro = /((\\\\)*)\\textquotedblleft/g;
    const rightQuoteMacro = /((\\\\)*)\\textquotedblright/g;
    const emdashMacro = /((\\\\)*)\\textemdash/g;
    return tex.replace(textNodes, (_, text) => {
        return `\\text{${text
            .replace(maybeEscapedAmpersands, "$1\\&")
            .replace(maybeEscapedPercentSigns, "$1\\%")
            .replace(maybeEscapedHashtags, "$1\\#")
            .replace(leftQuoteMacro, "$1“")
            .replace(rightQuoteMacro, "$1”")
            .replace(emdashMacro, "$1—")}}`;
    });
}
